import { useMutation } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import { toasterApi } from '@terra/ui-design-system';
import type { MergeAssetsPublicBodyDto } from '@terra/shared-contracts-applications';
import { terraProxyApiClient } from '../../clients/testerClient';
import {
  assetMergeToastTitleKey,
  isAssetMergeReviseCommand,
} from '../../utils/asset-merge/asset-merge-selection';

export function useMergeAssets() {
  const t = useTranslations('proxy.assets.merge');

  return useMutation({
    mutationFn: ({
      applicationId,
      body,
    }: {
      applicationId: string;
      body: MergeAssetsPublicBodyDto;
    }) => terraProxyApiClient.mergeAssets({ applicationId, body }),
    onSuccess: (_data, { body }) => {
      toasterApi.success({
        title: t(
          assetMergeToastTitleKey({
            outcome: 'started',
            isRevise: isAssetMergeReviseCommand({
              survivorKind: body.survivor.kind,
              loserCount: body.loserIds.length,
            }),
          }),
        ),
      });
    },
    onError: (error: unknown, { body }) => {
      toasterApi.error({
        title: t(
          assetMergeToastTitleKey({
            outcome: 'error',
            isRevise: isAssetMergeReviseCommand({
              survivorKind: body.survivor.kind,
              loserCount: body.loserIds.length,
            }),
          }),
        ),
        description: error instanceof Error ? error.message : undefined,
      });
    },
  });
}
